import React, { useState, useEffect, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import { SendPostRequest } from "../../http";
import Captcha from "../Captcha/Captcha";
import HeaderWrapper from "../Header/HeaderWrapper";
import FooterWrapper from "../Footer/FooterWrapper";
import TextMainBannerWrapper from "../TextMainBanners/TextMainBannerWrapper";

function Feedback() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [complaintData, setComplaintData] = useState({
    full_name: null,
    mrn: "",
    email: "",
    contact_number: "",
    complaint_detail: "",
    complaint_attachment_1: null,
    complaint_attachment_2: null,
  });

  function capitalize(str) {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    handleRefresh();
  }, []);

  const handlePostData = (e) => {
    let { value, name } = e.target;
    setComplaintData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    let name = e.target.name;
    let file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result.split(",")[1];
      setComplaintData((prevData) => ({
        ...prevData,
        [name]: base64String,
      }));
    };
    reader.readAsDataURL(file);
  };

  const [captcha, setCaptcha] = useState("");
  const [input_captcha, setInputCaptcha] = useState("");
  const [check_captcha, setCheckCaptcha] = useState("");
  const formRef = useRef(null);
  const fullNameRef = useRef(null);
  const contactNumberRef = useRef(null);
  const emailRef = useRef(null);
  const feedbackRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate Full Name
    if (!complaintData.full_name || complaintData.full_name.trim() === "") {
      toast.error("Please enter your full name");
      fullNameRef.current?.focus();
      return;
    }
    
    // Validate Contact Number
    if (!complaintData.contact_number || complaintData.contact_number.trim() === "") {
      toast.error("Please enter your contact number");
      contactNumberRef.current?.focus();
      return;
    } else if (
      complaintData.contact_number.length > 14 ||
      complaintData.contact_number.length < 10
    ) {
      toast.error("Please enter a valid contact number (10-14 digits)");
      contactNumberRef.current?.focus();
      return;
    }
    
    // Validate Email (if provided)
    if (complaintData.email && complaintData.email.trim() !== "") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(complaintData.email)) {
        toast.error("Please enter a valid email address");
        emailRef.current?.focus();
        return;
      }
    }
    
    // Validate Feedback/Complaint Detail
    if (!complaintData.complaint_detail || complaintData.complaint_detail.trim() === "") {
      toast.error("Please enter your feedback");
      feedbackRef.current?.focus();
      return;
    }
    
    // Validate Captcha
    if (!input_captcha || input_captcha.trim() === "") {
      toast.error("Please enter the captcha code");
      setTimeout(() => {
        const captchaInput = document.getElementById("captchaInput");
        if (captchaInput) captchaInput.focus();
      }, 100);
      return;
    } else if (captcha !== input_captcha) {
      toast.error("Invalid captcha code. Please try again");
      setTimeout(() => {
        const captchaInput = document.getElementById("captchaInput");
        if (captchaInput) {
          captchaInput.focus();
          captchaInput.select();
        }
      }, 100);
      return;
    }

    if (captcha === input_captcha) {
      setCheckCaptcha("Captcha Verified");
      try {
        setIsSubmitting(true);
        const response = await SendPostRequest("complaints/add", complaintData);
        formRef.current.reset();

        if (response.status === "success") {
          setComplaintData({
            full_name: null,
            mrn: "",
            email: "",
            contact_number: "",
            complaint_detail: "",
            complaint_attachment_1: null,
            complaint_attachment_2: null,
          });
          handleRefresh();
          setInputCaptcha(null);
          setCheckCaptcha(null);

          toast.success("Feedback has been submitted successfully");
        } else {
          let errorMessage = response.message || "An error occurred";
          toast.error(`Error: ${errorMessage}`);
          console.error("Error fetching feedback data:", errorMessage);
        }
      } catch (error) {
        toast.error(`Error: ${error.message}`);
        console.error("Error fetching feedback data:", error);
      } finally {
        setIsSubmitting(false);
      }
    } else {
      setCheckCaptcha("Captcha failed");
      toast.error("Captcha failed");
      return;
    }
  };

  const textColorClass =
    check_captcha === "Captcha Verified" ? "text-success" : "text-danger";

  const handleInputChange = (e) => {
    setInputCaptcha(e.target.value);
  };

  const handleRefresh = () => {
    const newCaptcha = generateRandomCaptcha();
    setCaptcha(newCaptcha);
  };

  const generateRandomCaptcha = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const captchaLength = 6;
    let newCaptcha = "";

    for (let i = 0; i < captchaLength; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      newCaptcha += characters.charAt(randomIndex);
    }

    return newCaptcha;
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="page-wrapper-inner">
      <div class="page-wrapper-inner">
        <HeaderWrapper />
        <TextMainBannerWrapper Heading="Feedback" Image="theme-2-banner-feedback.webp" />

        {
          sitedata?.theme_feedback_form === "colored" ? (
            <div className="feedback-wrapper pt-4" style={{ background: "#000" }}>
              <div className="container ">
                <div className="contact-form" data-animation="fadeInLeft" >
                  <form ref={formRef} onSubmit={handleSubmit}>
                    <div className="cs_contact_form cs_style_1 cs_white_bg cs_radius_30">
                      <div className="row p-4">
                        <div className="col-lg-6">


                          <div className="row">
                            <div className="col-lg-12 mb-3 color-form-inputs">
                              <label className="form-label mb-0">
                                Full Name <span className="asterisk">*</span>
                              </label>
                              <input
                                ref={fullNameRef}
                                type="text"
                                className="input-name form-control "
                                name="full_name"
                                value={complaintData.full_name || ""}
                                onChange={handlePostData}
                                placeholder=""
                              />
                              <div className="cs_height_42 cs_height_xl_25"></div>
                            </div>
                            <div className="col-lg-12 mb-3 color-form-inputs">
                              <label className="form-label mb-0">Email</label>
                              <input
                                ref={emailRef}
                                type="email"
                                className="input-name form-control "
                                name="email"
                                value={complaintData.email || ""}
                                onChange={handlePostData}
                                placeholder=""
                              />
                              <div className="cs_height_42 cs_height_xl_25"></div>
                            </div>
                            <div className="col-lg-12 mb-3 color-form-inputs">
                              <label className="form-label mb-0">MRN #</label>
                              <input
                                type="text"
                                className="input-name form-control "
                                name="mrn"
                                value={complaintData.mrn || ""}
                                onChange={handlePostData}
                                placeholder=""
                              />
                              <div className="cs_height_42 cs_height_xl_25"></div>
                            </div>

                            <div className="col-lg-12 mb-3 color-form-inputs">
                              <label className="form-label mb-0">
                                Contact No <span className="asterisk">*</span>
                              </label>
                              <input
                                ref={contactNumberRef}
                                type="text"
                                className="input-name form-control "
                                name="contact_number"
                                value={complaintData.contact_number || ""}
                                onChange={handlePostData}
                                placeholder=""
                                maxLength={14}
                                minLength={10}
                              />
                              <div className="cs_height_42 cs_height_xl_25"></div>
                            </div>
                            {!isMobile ? (
                              <div className="col-lg-12 mb-3 appointment_form_capcha colored-feedback-capcha">
                                <label className="form-label">Captcha</label>
                                <Captcha
                                  captcha={captcha}
                                  inputCaptcha={input_captcha}
                                  textColorClass={textColorClass}
                                  checkCaptcha={check_captcha}
                                  handleInputChange={handleInputChange}
                                />
                              </div>
                            ) : null}
                          </div>


                        </div>
                        <div className="col-lg-6">
                          <div className="row">
                            <div className="col-lg-12 mb-3">
                              <label className="form-label text-white">
                                Feedback <span className="asterisk">*</span>
                              </label>
                              <textarea
                                ref={feedbackRef}
                                cols="30"
                                rows="6"
                                className="input-name form-control"
                                placeholder="Enter your feedback..."
                                name="complaint_detail"
                                value={complaintData.complaint_detail || ""}
                                onChange={handlePostData}
                              ></textarea>
                              <div className="cs_height_42 cs_height_xl_25"></div>
                            </div>
                          </div>
                          <div className="row">

                            <div className="col-lg-12 mb-3 colored-feedback-attachment">
                              <label className="form-label">Attachment 1</label>
                              <input
                                type="file"
                                className="input-name form-control drop_cv_pic_upoload_field"
                                placeholder="example@gmail.com"
                                name="complaint_attachment_1"
                                onChange={handleFileChange}
                                accept="image/*"
                              />
                              <div className="cs_height_42 cs_height_xl_25"></div>
                            </div>
                            <div className="col-lg-12 mb-3 colored-feedback-attachment">
                              <label className="form-label">Attachment 2</label>
                              <input
                                type="file"
                                className="input-name form-control drop_cv_pic_upoload_field"
                                placeholder="example@gmail.com"
                                name="complaint_attachment_2"
                                // value={Complaints.complaint_attachment_2}
                                file={null}
                                onChange={handleFileChange}
                                accept="image/*"
                              />
                              <div className="cs_height_42 cs_height_xl_25"></div>
                            </div>
                            {isMobile ? (
                              <div className="col-lg-12 mb-0 appointment_form_capcha colored-feedback-capcha">
                                <label className="form-label">Captcha</label>
                                <Captcha
                                  captcha={captcha}
                                  inputCaptcha={input_captcha}
                                  textColorClass={textColorClass}
                                  checkCaptcha={check_captcha}
                                  handleInputChange={handleInputChange}
                                />
                              </div>
                            ) : null}
                            <div className="col-lg-12 mb-3">
                              <div className="cs_height_18"></div>
                              <div className="d-flex justify-content-end colored-feedback-btn">
                                <button
                                  type="submit"
                                  disabled={isSubmitting}
                                  className="btn"
                                  style={{ width: "105px" }}
                                >
                                  {isSubmitting ? "Submitting..." : "Submit"}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>





                      </div>
                    </div>
                  </form>
                </div>
              </div>

            </div>
          ) : (
            <div >
              <div className="container mt-4">
                <div className="contact-form" data-animation="fadeInLeft" >
                  <form ref={formRef} onSubmit={handleSubmit}>
                    <div className="cs_contact_form cs_style_1 cs_white_bg cs_radius_30">
                      <div className="row p-4">
                        <div className="col-lg-6">

                          <div className="row">

                            <div className="col-lg-12 mb-3 light-inputs-wrapper">
                              <label className="form-label mb-0">
                                Full Name <span className="asterisk">*</span>
                              </label>
                              <input
                                ref={fullNameRef}
                                type="text"
                                className="input-name form-control "
                                name="full_name"
                                value={complaintData.full_name || ""}
                                onChange={handlePostData}
                                placeholder="Enter Full Name"
                              />
                              <div className="cs_height_42 cs_height_xl_25"></div>
                            </div>
                            <div className="col-lg-12 mb-3 light-inputs-wrapper">
                              <label className="form-label mb-0">Email</label>
                              <input
                                ref={emailRef}
                                type="email"
                                className="input-name form-control "
                                name="email"
                                value={complaintData.email || ""}
                                onChange={handlePostData}
                                placeholder="Enter Email Address"
                              />
                              <div className="cs_height_42 cs_height_xl_25"></div>
                            </div>
                            <div className="col-lg-12 mb-3 light-inputs-wrapper">
                              <label className="form-label mb-0">MRN #</label>
                              <input
                                type="text"
                                className="input-name form-control "
                                name="mrn"
                                value={complaintData.mrn || ""}
                                onChange={handlePostData}
                                placeholder="Enter MRN No"
                              />
                              <div className="cs_height_42 cs_height_xl_25"></div>
                            </div>

                            <div className="col-lg-12 mb-3 light-inputs-wrapper">
                              <label className="form-label mb-0">
                                Contact No <span className="asterisk">*</span>
                              </label>
                              <input
                                ref={contactNumberRef}
                                type="text"
                                className="input-name form-control "
                                name="contact_number"
                                value={complaintData.contact_number || ""}
                                onChange={handlePostData}
                                placeholder="Enter Contact No"
                                maxLength={14}
                                minLength={10}
                              />
                              <div className="cs_height_42 cs_height_xl_25"></div>
                            </div>
                            {!isMobile ? (
                              <div className="col-lg-12 mb-3 appointment_form_capcha light-inputs-wrapper">
                                <label className="form-label">Captcha</label>
                                <Captcha
                                  captcha={captcha}
                                  inputCaptcha={input_captcha}
                                  textColorClass={textColorClass}
                                  checkCaptcha={check_captcha}
                                  handleInputChange={handleInputChange}
                                />
                              </div>
                            ) : null}
                          </div>


                        </div>
                        <div className="col-lg-6">
                          <div className="row">
                            <div className="col-lg-12 mb-3 light-inputs-wrapper">
                              <label className="form-label mb-0 ">
                                Feedback <span className="asterisk">*</span>
                              </label>
                              <textarea
                                ref={feedbackRef}
                                cols="30"
                                rows="6"
                                className="input-name form-control"
                                placeholder="Enter your feedback..."
                                name="complaint_detail"
                                value={complaintData.complaint_detail || ""}
                                onChange={handlePostData}
                              ></textarea>
                              <div className="cs_height_42 cs_height_xl_25"></div>
                            </div>
                          </div>
                          <div className="row">

                            <div className="col-lg-12 mb-3 light-feedback-attachment">
                              <label className="form-label mb-0">Attachment 1</label>
                              {/* <input
                            type="file"
                            className="input-name form-control drop_cv_pic_upoload_field"
                            placeholder="example@gmail.com"
                            name="complaint_attachment_1"
                            onChange={handleFileChange}
                            accept="image/*"
                          /> */}
                              <input
                                className="input-name form-control drop_cv_pic_upoload_field"
                                type="file"
                                // multiple
                                name="complaint_attachment_1"
                                onChange={handleFileChange}
                              />

                              <div className="cs_height_42 cs_height_xl_25"></div>
                            </div>
                            <div className="col-lg-12 mb-3 light-feedback-attachment">
                              <label className="form-label mb-0">Attachment 2</label>
                              {/* <input
                            type="file"
                            className="input-name form-control drop_cv_pic_upoload_field"
                            placeholder="example@gmail.com"
                            name="complaint_attachment_2"
                            file={null}
                            onChange={handleFileChange}
                            accept="image/*"
                          /> */}
                              <input
                                type="file"
                                className="input-name form-control drop_cv_pic_upoload_field"
                                name="complaint_attachment_2"
                                onChange={handleFileChange}
                              />

                              <div className="cs_height_42 cs_height_xl_25"></div>
                            </div>
                            {isMobile ? (
                              <div className="col-lg-12 mb-0 appointment_form_capcha light-inputs-wrapper">
                                <label className="form-label">Captcha</label>
                                <Captcha
                                  captcha={captcha}
                                  inputCaptcha={input_captcha}
                                  textColorClass={textColorClass}
                                  checkCaptcha={check_captcha}
                                  handleInputChange={handleInputChange}
                                />
                              </div>
                            ) : null}
                            <div className="col-lg-12 mb-3">
                              <div className="cs_height_18"></div>
                              <div className="d-flex justify-content-end align-items-end">
                                <button
                                  type="submit"
                                  disabled={isSubmitting}
                                  className="btn btn-default"
                                  style={{ width: "105px" }}
                                >
                                  {isSubmitting ? "Submitting..." : "Submit"}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>


          )}




        <FooterWrapper />
      </div>
    </div>
  );
}

export default Feedback;
